export type CraftRecipe = {
  ing1: string;
  ing2: string;
  result: string;
  label: string;
  dustCost?: number;
  isWeapon?: boolean;
  isArmor?: boolean;
};

export const CRAFTING_RECIPES: CraftRecipe[] = [
  { ing1: 'Leather', ing2: 'Claws', result: 'Meat', label: 'Meat' },
  { ing1: 'Claws', ing2: 'Leather', result: 'Meat', label: 'Meat' },
  { ing1: 'Pink Fur', ing2: 'Claws', result: 'Pink Hunter Fur Shoulderpads', label: 'Shoulderpads', isArmor: true, dustCost: 40 },
  { ing1: 'Claws', ing2: 'Pink Fur', result: 'Pink Hunter Fur Shoulderpads', label: 'Shoulderpads', isArmor: true, dustCost: 40 },
  { ing1: 'Pink Fur', ing2: 'Leather', result: 'Unfinished Pink Hunter Fur Coat', label: 'Unfinished Coat', isArmor: true, dustCost: 40 },
  { ing1: 'Leather', ing2: 'Pink Fur', result: 'Unfinished Pink Hunter Fur Coat', label: 'Unfinished Coat', isArmor: true, dustCost: 40 },
  { ing1: 'Wood Drop', ing2: 'Stone drop', result: 'Nerd Weapon', label: 'Nerd Weapon' },
  { ing1: 'Stone drop', ing2: 'Wood Drop', result: 'Nerd Weapon', label: 'Nerd Weapon' },
  { ing1: 'Wood', ing2: 'Stone', result: 'Nerd Weapon', label: 'Nerd Weapon' },
  { ing1: 'Stone', ing2: 'Wood', result: 'Nerd Weapon', label: 'Nerd Weapon' },
  { ing1: 'Wood Drop', ing2: 'Claws', result: 'WoodClub', label: 'Wood Club' },
  { ing1: 'Claws', ing2: 'Wood Drop', result: 'WoodClub', label: 'Wood Club' },
];
